/* StylinArts – Collection / Grid Wishlist Hearts
 * - Binds to buttons with [data-sa-wishlist-heart]
 * - Talks to Cloudflare Wishlist API (same as PDP + Wishlist page)
 * - Keeps header badge in sync if saWishlistHeaderRefresh exists
 */

(() => {
  "use strict";

  const API_BASE = "https://wishlist-api.stylinarts.com/_wishlist";
  const BTN_SEL  = "[data-sa-wishlist-heart]";

  function normalizeItems(payload) {
    const raw = Array.isArray(payload)
      ? payload
      : (payload && Array.isArray(payload.items) ? payload.items : []);

    return raw
      .map(it => {
        if (typeof it === "string") {
          return { handle: it, product_id: null };
        }
        if (it && typeof it === "object") {
          const handle     = it.product_handle || it.handle || it.slug || "";
          const product_id = it.product_id || it.productId || it.id || null;
          return { handle, product_id };
        }
        return null;
      })
      .filter(Boolean)
      .filter(x => typeof x.handle === "string" && x.handle.length);
  }

  async function apiGetWishlist() {
    const res = await fetch(API_BASE, { credentials: "include" });
    if (!res.ok) throw new Error(`Wishlist API GET failed (${res.status})`);
    return res.json();
  }

  async function apiToggle(product_id, product_handle) {
    const body = {};
    if (product_id)      body.product_id      = product_id;
    if (product_handle)  body.product_handle  = product_handle;

    const res = await fetch(`${API_BASE}/toggle`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      credentials: "include"
    });

    if (!res.ok) throw new Error(`Wishlist API toggle failed (${res.status})`);
    return res.json().catch(() => ({}));
  }

  function setBtnState(btn, isOn) {
    btn.classList.toggle("is-on", !!isOn);
    btn.setAttribute("aria-pressed", isOn ? "true" : "false");
  }

  async function refreshAll() {
    const btns = Array.from(document.querySelectorAll(BTN_SEL));
    if (!btns.length) return;

    let items = [];
    try {
      const payload = await apiGetWishlist();
      items = normalizeItems(payload);
    } catch (e) {
      console.error(e);
      return;
    }

    const handles = new Set(items.map(x => x.handle));
    const ids     = new Set(items.map(x => String(x.product_id || "")));

    btns.forEach(btn => {
      const handle = btn.getAttribute("data-product-handle") || "";
      const pid    = btn.getAttribute("data-product-id") || "";
      const match  =
        (handle && handles.has(handle)) ||
        (pid && ids.has(String(pid)));

      setBtnState(btn, match);
    });
  }

  function bindOnce() {
    if (document.documentElement.dataset.saWishlistCollectionBound === "1") return;
    document.documentElement.dataset.saWishlistCollectionBound = "1";

    document.addEventListener("click", async (ev) => {
      const btn = ev.target.closest(BTN_SEL);
      if (!btn) return;

      const pidRaw        = btn.getAttribute("data-product-id") || "";
      const product_id    = pidRaw ? Number(pidRaw) : null;
      const productHandle = btn.getAttribute("data-product-handle") || "";

      if (!product_id && !productHandle) return;

      btn.classList.add("is-loading");
      btn.disabled = true;

      try {
        await apiToggle(product_id, productHandle);
        await refreshAll();

        // ping header badge if present
        if (typeof window.saWishlistHeaderRefresh === "function") {
          window.saWishlistHeaderRefresh();
        }
      } catch (e) {
        console.error(e);
      } finally {
        btn.classList.remove("is-loading");
        btn.disabled = false;
      }
    }, { passive: true });
  }

  function boot() {
    bindOnce();
    refreshAll();
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);

  // manual refresh hook if we ever need it
  window.saWishlistCardsRefresh = refreshAll;
})();
